module.exports = __webpack_public_path__ + "img/Support-skill-416.3e8d0f66.png";